import FilterDirection from './FilterDirection';
import wrapInObserver from '../wrapInObserver';
import logger from '../../logger';
import generatedHooks from '../../hooks/generatedHooks';
import strings from '../../strings';

const {
  useRootStore,
  useUiStore,
} = generatedHooks;

const mapProps = () => {
  try {
    const rootStore = useRootStore(store => store);

    const uiStore = useUiStore(store => store);
    const {
      reverse,
      setReverse,
    } = uiStore;

    const handleReverseChange = (value) => {
      setReverse(value);
      rootStore.reload();
    };

    const options = [
      {
        'label': strings.filter,
        'value': false,
      },
      {
        'label': strings.antiFilter,
        'value': true,
      }];

    const selectedOrder = reverse;

    return {
      handleReverseChange,
      selectedOrder,
      options,
    };
  } catch (error) {
    logger.error(error);
    return {};
  }
};

export default wrapInObserver(FilterDirection, mapProps);
